var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.158 7.842C9.54365 7.22793 8.71059 6.88297 7.84198 6.88297C6.97337 6.88297 6.14031 7.22793 5.52598 7.842L3.20923 10.158C2.59489 10.7723 2.24976 11.6056 2.24976 12.4744C2.24976 13.3432 2.59489 14.1764 3.20923 14.7908C3.82357 15.4051 4.6568 15.7502 5.5256 15.7502C6.39441 15.7502 7.22764 15.4051 7.84198 14.7908L8.99998 13.6328",
    stroke: "#838390",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.84198 10.158C8.45631 10.7721 9.28937 11.117 10.158 11.117C11.0266 11.117 11.8596 10.7721 12.474 10.158L14.7907 7.84201C15.4051 7.22767 15.7502 6.39444 15.7502 5.52564C15.7502 4.65683 15.4051 3.8236 14.7907 3.20926C14.1764 2.59492 13.3432 2.24979 12.4744 2.24979C11.6055 2.24979 10.7723 2.59492 10.158 3.20926L8.99998 4.36726",
    stroke: "#838390",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.b23574aaaf5417a6f48634adce655cbe.svg";
export { ForwardRef as ReactComponent };